import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'
import { CLIENT_SETTINGS } from 'constants/clientSettings'

/**
 * 共済系用グローバルフッター・全ての画面に適用するフッター
 */

const KsGlobalFooter: React.FC = () => {
  return (
    <React.Fragment>
      <KsAreaSpace />
      <KsArea>
        {
          CLIENT_SETTINGS.copyRight.map((copyLight: string) => {
            return <KsFooterText>{copyLight}</KsFooterText>
          })
        }
      </KsArea>
    </React.Fragment>
  )
}

const KsAreaSpace = styled.div`
  height: 70px;
`

const KsArea = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 70px;
  background: var(--color-main);
`

const KsFooterText = styled(Text)`
  color: var(--color-text-for-main-background);
  font-size: 12px;
  text-align: center;
`

export default KsGlobalFooter
